import { useState } from "react";
import { messageInfo, paperClip, userInfo } from "../../asset";
import ModalLayout from "../layouts/ModalLayout";
import AttachmentViewerModal from "./AttachmentViewModal";

interface Props {
  onClose: () => void;
  sender: string;
  message: string;
  attachment?: string;
}

export default function ReadMessageModal({
  onClose,
  sender,
  message,
  attachment,
}: Props) {
  const [showAttachment, setShowAttachment] = useState(false);

  return (
    <ModalLayout onClose={onClose} width="max-w-sm">
      <div className="flex flex-col gap-6">
        <Info icon={userInfo} label="Sender Name" description={sender} />

        <Info icon={messageInfo} label="Message" description={message} />

        {attachment && (
          <div className="flex flex-col gap-2">
            <Info icon={paperClip} label="Attachment" />
            <button
              onClick={() => {
                setShowAttachment(true);
              }}
              className="mt-1 w-fit px-7 py-1 bg-primary-800 text-white rounded text-[12px] font-medium"
            >
              View
            </button>
          </div>
        )}
        <p className="text-sm text-neutral-400 tracking-[-0.14px] text-end">
          {/* 21 Jan, 2026 11:00 AM */}
        </p>
        {showAttachment && attachment && (
          <AttachmentViewerModal
            fileUrl={attachment}
            onClose={() => setShowAttachment(false)}
          />
        )}
      </div>
    </ModalLayout>
  );
}

type infoProps = {
  icon: string;
  label: string;
  description?: string;
};
const Info = ({ icon, label, description }: infoProps) => {
  return (
    <div className="flex flex-col gap-[3px]">
      <div className="flex gap-[6px]">
        <img src={icon} alt="" />
        <label className="text-[13px] text-neutral-300">{label}</label>
      </div>
      <h4 className="text-sm text-neutral-500 font-medium">{description}</h4>
    </div>
  );
};
